export default __webpack_public_path__ + "static/media/480_portfolio03-en-web.7c87a543.png";